import { CdkDragDrop, moveItemInArray, transferArrayItem, CDK_DROP_LIST_GROUP } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ALERTS, FormGroup } from 'src/app/common';
import { IPermission, IRole, IUser } from 'src/app/models';
import { AlertService, BlockUiHandlerService, PermissionService, StorageService, UserService } from 'src/app/services';
import { RoleService } from 'src/app/services/role.service';
@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent implements OnInit {
  roleForm: FormGroup;
  roles: IRole[];
  role: IRole;
  assignedRoles: IRole[];
  Assignedpermissions: IPermission[];
  permissions: IPermission[];
  permissionForm: FormGroup;
  modalReference: NgbModalRef;
  users: IUser[];

  constructor(private roleService: RoleService,private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private blockUiService: BlockUiHandlerService,
    private permissionService: PermissionService,
    private storageService: StorageService,private userService: UserService) { }

  ngOnInit(): void {
    this.InitVariables();
    this.LoadData();
    
  }

  InitVariables(): void {
    this.users = [];
    this.Assignedpermissions = [];
    this.permissions = [];
    this.assignedRoles = [];
    this.roles = [];
    this.ResetPermissionForm();
    this.ResetRoleForm();
  }

  LoadData(): void {
    this.GetPermissions();
    this.GetRoles();
  }

  RaisePermissionModal(content, isUpdating: boolean = false, _isOnRole = false): void {
    if (_isOnRole) {
      if (!isUpdating) this.ResetRoleForm();
    }
    else {
      if (!isUpdating) this.ResetPermissionForm();
    }
    this.modalReference = this.modalService.open(content,
      {
        centered: true,
        backdrop: 'static'
      });
  }

  ResetPermissionForm(): void {
    this.permissionForm = this.formBuilder.group({
      Id: [-1],
      Name: ['', Validators.required],
      Code: ['', Validators.required],
      Type: ['', Validators.required],
      IsActive: [true, Validators.required]
    });
  }

  ResetRoleForm(): void {
    this.roleForm = this.formBuilder.group({
      Id: [-1],
      Name: ['', Validators.required],
      IsActive: [true, Validators.required],
      //Code: ['', Validators.required]
    });
  }

  OffsetPermissions(_option: number): void {
    if (_option === 0) {
      this.Assignedpermissions.forEach(x => this.permissions.push({ ...x }));
      this.Assignedpermissions = [];
    }
    else {
      this.Assignedpermissions.concat(this.permissions);
      this.permissions.forEach(x => this.Assignedpermissions.push({ ...x }));
      this.permissions = [];
    }

    this.permissionService.PutByRole(this.roles.find(x => x.IsSelected).Id, this.Assignedpermissions).subscribe(next => {
      if (next.Result) {
        this.alertService.ShowSmallCornerAlert(`Permisos asignados`, ALERTS.success);
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next?.ErrorInfo?.Message || ''}`, ALERTS.warning);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  GetRoles(_filtered = false, _onAssignation = false): void {
    this.blockUiService.Start(1);
    this.roleService.Get().subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.roles = next.Roles;
        
        if (this.roles.length > 0) {
          this.roles.forEach(x => x.IsSelected = false);
          this.roles[0].IsSelected = true;
        }

        if (_filtered) this.roles = next.Roles.filter(x => x.IsActive);

        if (_onAssignation) {
          this.assignedRoles.forEach(x => {
            this.roles = this.roles.filter(y => y.Id != x.Id);
          });
        }
        if (this.roles.length > 0) this.SelectRole(this.roles[0]);
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next?.ErrorInfo?.Message || ''}`, ALERTS.warning);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  SelectRole(_role: IRole) {
    this.roles.forEach(x => x.IsSelected = false);
    this.roles.find(x => x.Id === _role.Id).IsSelected = true;

    this.permissionService.GetPermissionsByRole(_role.Id).subscribe(next => {
      if (next.Result) {
        this.Assignedpermissions = next.Permissions;
        this.GetPermissions(true, true);
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next?.ErrorInfo?.Message || ''}`, ALERTS.error);
      }

    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }
  GetPermissions(_filtered = false, _onAssignation = false): void {
    this.blockUiService.Start(1);
    this.permissionService.Get().subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.permissions = next.Permissions;
        if (_filtered) this.permissions = next.Permissions.filter(x => x.IsActive);

        if (_onAssignation) {
          this.Assignedpermissions.forEach(x => {
            this.permissions = this.permissions.filter(y => y.Id != x.Id);
          });
        }
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.warning);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
    });
  }
  UpdateRole(_role: IRole): void {
    this.blockUiService.Start(1, `actualizando rol, espere por favor`);
    this.roleService.Put(_role).subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.roles.find(x => x.Id === _role.Id).IsActive = _role.IsActive;
        this.alertService.ShowSmallCornerAlert(`Rol actualizado`, ALERTS.success);
        this.ClosePermissionModal();

        this.OverridePermissions();
      }
      else {
        this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  CreateRole(_role: IRole): void {
    this.blockUiService.Start(1, `Agregando rol, espere por favor`);
    this.roleService.Post(_role).subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.alertService.ShowSmallCornerAlert(`Rol agregado`, ALERTS.success);
        this.ClosePermissionModal();
        this.GetRoles();
      }
      else {
        this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }
  ClosePermissionModal(): void {
    this.modalReference.close();
  }

  private OverridePermissions(): void {
    const USER = JSON.parse(this.storageService.GetCurrentSession());
    if (USER) {
      this.permissionService.GetPermissionsByUser(+USER.Id).subscribe(next => {
        if (next.Result && next.Permissions && next.Permissions.length > 0) {
          this.storageService.SetPermissions(next.Permissions);
        }
        else {
          this.alertService.ShowSmallCornerAlert(`No se pudieron recargar los permisos`, ALERTS.warning);
        }
      }, error => {
        this.alertService.ShowSmallCornerAlert(`No se pudieron recargar los permisos`, ALERTS.warning);
      });
    }
    else {
      this.alertService.ShowSmallCornerAlert(`No se pudieron recargar los permisos`, ALERTS.warning);
    }
  }
  drop(event: CdkDragDrop<string[]>, _isOnRoleTab = true) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
      if (_isOnRoleTab) {
        this.permissionService.PutByRole(this.roles.find(x => x.IsSelected).Id, this.Assignedpermissions).subscribe(next => {
          if (next.Result) {
            const PLURALIZED = this.Assignedpermissions.length > 0 ? 's' : '';
            this.alertService.ShowSmallCornerAlert(`Role${PLURALIZED} asignado${PLURALIZED}`, ALERTS.success);
            this.OverridePermissions();
          }
          else {
            this.alertService.ShowSmallCornerAlert(`Error: ${next?.ErrorInfo?.Message || ''}`, ALERTS.warning);
          }
        }, error => {
          this.blockUiService.Stop();
          this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
        });
      }
      else {
        this.userService.PutByRole(this.users.find(x => x.IsSelected).Id, this.assignedRoles).subscribe(next => {
          if (next.Result) {
            const PLURALIZED = this.assignedRoles.length > 0 ? 's' : '';
            this.alertService.ShowSmallCornerAlert(`Role${PLURALIZED} asignado${PLURALIZED}`, ALERTS.success);
            this.OverridePermissions();
          }
          else {
            this.alertService.ShowSmallCornerAlert(`Error: ${next?.ErrorInfo?.Message || ''}`, ALERTS.warning);
          }
        }, error => {
          this.blockUiService.Stop();
          this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
        });
      }
    }
  }
 
  GetRole(_id: number, content: unknown): void {
    this.roleService.GetRole(_id).subscribe(next => {
    
      if (next.Result) {
        this.roleForm.patchValue({ ...next.Role });
       
        this.RaisePermissionModal(content, true, true);
      }
      else {
        this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  Store(): void {

      const ROLE = this.roleForm.value as IRole;

      if (!this.roleForm.valid) {
        this.alertService.ShowSmallCornerAlert(`Todos los campos son requeridos`, ALERTS.info);
        return;
      }

      ROLE.Id === -1 ? this.CreateRole(ROLE) : this.UpdateRole(ROLE);
  }
}
